import { NewsServiceName } from "@bluframe/mightychroma-mightytool-frontend-types"
import PodSource from "components/News/PodSource"

import { ComponentProps } from "."
import { Ul, Wrapper } from "./styled"

const HeaderPods = ({
  areNewsLoading,
  avNirvana,
  bluRay,
  hidefDigest,
  news,
  isCompact,
  isSingleSource,
  left,
  onClear,
  onSetOverrides,
  whySoBlu
}: ComponentProps) => (
  <Wrapper>
    {left}

    {isSingleSource ? null : (
      <Ul $isCompact={isCompact} aria-label="Header Pods">
        <li aria-label="Blu-ray.com">
          <PodSource
            areNewsLoading={areNewsLoading}
            isCompact={isCompact}
            isCreated={Boolean(news.sourcesIds?.includes(bluRay.id))}
            isLoading={bluRay.isPreviewLoading}
            isValid={bluRay.isPreviewValid}
            label="Blu-ray.com"
            onClear={onClear}
            onSetOverrides={onSetOverrides}
            overrides={bluRay.overrides}
            serviceName={"bluRay" as NewsServiceName}
            text={bluRay.url}
          />
        </li>

        <li aria-label="AV Nirvana">
          <PodSource
            areNewsLoading={areNewsLoading}
            isCompact={isCompact}
            isCreated={Boolean(news.sourcesIds?.includes(avNirvana.id))}
            isLoading={avNirvana.isPreviewLoading}
            isValid={avNirvana.isPreviewValid}
            label="AV Nirvana"
            onClear={onClear}
            onSetOverrides={onSetOverrides}
            overrides={avNirvana.overrides}
            serviceName={"avNirvana" as NewsServiceName}
            text={avNirvana.url}
          />
        </li>

        <li aria-label="Hi-Def Digest">
          <PodSource
            areNewsLoading={areNewsLoading}
            isCompact={isCompact}
            isCreated={Boolean(news.sourcesIds?.includes(hidefDigest.id))}
            isLoading={hidefDigest.isPreviewLoading}
            isValid={hidefDigest.isPreviewValid}
            label="Hi-Def Digest"
            onClear={onClear}
            onSetOverrides={onSetOverrides}
            overrides={hidefDigest.overrides}
            serviceName={"hidefDigest" as NewsServiceName}
            text={hidefDigest.url}
          />
        </li>

        <li aria-label="Why So Blu?">
          <PodSource
            areNewsLoading={areNewsLoading}
            isCompact={isCompact}
            isCreated={Boolean(news.sourcesIds?.includes(whySoBlu.id))}
            isLoading={whySoBlu.isPreviewLoading}
            isValid={whySoBlu.isPreviewValid}
            label="Why So Blu?"
            onClear={onClear}
            onSetOverrides={onSetOverrides}
            overrides={whySoBlu.overrides}
            serviceName={"whySoBlu" as NewsServiceName}
            text={whySoBlu.url}
          />
        </li>
      </Ul>
    )}
  </Wrapper>
)

export default HeaderPods
